"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveAlarmsBadge = ActiveAlarmsBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var alarm_1 = require("../../features/apis/alarm");
var hooks_1 = require("../../store/hooks");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
var use_has_permission_1 = require("../../utils/use-has-permission");
var text_component_1 = require("../ui/text-component");
function ActiveAlarmsBadge(props) {
    var _a, _b;
    var isExpanded = props.isExpanded;
    var POLL_INTERVAL_MS = 60000;
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var userId = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a._uid; });
    var canViewAlarms = (0, use_has_permission_1.useHasPermission)("view_alarms");
    var _c = (0, alarm_1.useGetActiveAlarmCountQuery)({ clientId: clientId, userId: userId !== null && userId !== void 0 ? userId : "" }, { skip: !userId || !canViewAlarms, pollingInterval: POLL_INTERVAL_MS }), data = _c.data, isError = _c.isError;
    var activeCount = isError ? 0 : ((_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0);
    if (!activeCount) {
        return null;
    }
    if (!isExpanded) {
        return (0, jsx_runtime_1.jsx)("div", { className: "absolute right-2 top-1.5 h-2 w-2 rounded-full bg-red-500", "aria-label": "".concat(activeCount, " active alarms") });
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "ml-auto flex h-5 min-w-6 shrink-0 items-center justify-center rounded-full bg-red-500 px-1.5", "aria-label": "".concat(activeCount, " active alarms"), children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", weight: "bold", color: "white", label: activeCount > 99 ? "99+" : String(activeCount) }) }));
}
